import { render, staticRenderFns } from "./TenantCard.vue?vue&type=template&id=0cb4781b&scoped=true"
import script from "./TenantCard.vue?vue&type=script&lang=js"
export * from "./TenantCard.vue?vue&type=script&lang=js"
import style0 from "./TenantCard.vue?vue&type=style&index=0&id=0cb4781b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb4781b",
  null
  
)

export default component.exports